export enum FeatureFlagKey {
  TasksModule = "tasks-module",
  DocumentAI = "document-ai",
  SuggestedTasks = "suggested-tasks",
  TaskCalendarICSIntegration = "task-calendar-ics-integration",
}

export type FeatureFlagMap = Record<FeatureFlagKey, boolean>;

export interface FeatureFlagStore {
  getAllForTenant(tenantId: string): Promise<Partial<FeatureFlagMap>>;
  setFlag(
    tenantId: string,
    key: FeatureFlagKey,
    value: boolean,
    audit: { userId: string }
  ): Promise<void>;
}

export type FeatureFlagDefinition = Readonly<{
  key: FeatureFlagKey;
  label: string;
  description: string;
}>;

// Single source of truth for Encamp-managed feature flags and their metadata.
export const FEATURE_FLAG_DEFS: readonly FeatureFlagDefinition[] = [
  {
    key: FeatureFlagKey.TasksModule,
    label: "Tasks module",
    description: "Enable the Tasks module for this organization.",
  },
  {
    key: FeatureFlagKey.DocumentAI,
    label: "Document AI",
    description: "Enable document enrichment and parsing via Document AI.",
  },
  {
    key: FeatureFlagKey.SuggestedTasks,
    label: "Suggested Tasks",
    description: "Enable AI-powered task suggestions based on uploaded documents.",
  },
  {
    key: FeatureFlagKey.TaskCalendarICSIntegration,
    label: "Task Calendar ICS Integration",
    description:
      "Enable ICS calendar subscription feeds for tasks. Users can subscribe to their tasks in external calendar apps.",
  },
] as const;

export const KNOWN_FEATURE_FLAG_KEYS = FEATURE_FLAG_DEFS.map(
  (d) => d.key
) as readonly FeatureFlagKey[];

export const FEATURE_FLAG_META_BY_KEY: Readonly<
  Record<FeatureFlagKey, { label: string; description: string }>
> = FEATURE_FLAG_DEFS.reduce(
  (acc, def) => {
    acc[def.key] = { label: def.label, description: def.description };
    return acc;
  },
  {} as Record<FeatureFlagKey, { label: string; description: string }>
);
